const state = {
  modals: {
    mainLogIn: false,
    mainRegistration: false,
    oldSignup: false,
    loginForm: false,
    signupForm: false,
    resetForm: false,
    resetPassword: false,
    shareRide: false,
    copyPrivateLink: false,
    attraction: false,
    pleaseAddTheRideToYourList: false,
    updateAttractionTime: false,
    pleaseLogInInOrderToEditRide: false,
    areYouShureRemovingAttraction: false,
    areYouShureRemovingDay: false,
    confirmRemoveDayWithExtraInfo: false,
    confirmForceAddDay: false,
    confirmForceRemoveDay: false,
    confirmForceUpdateRideInformation: false,
    moveDayAttractions: false,
    doYouWantToAddThisPointToRide: false,
    dynamicModal: false,
    loadingIcon: false,
    LoadingIconWithUploadStatus: false,
    existingAttractionOptions: false,
    attractionManagerOptions: false,
    dayManagerOptions: false,
    updateNotification: false,
    contactForm: false,
    insufficientBalanceModal: false,
    masterAccommodationCompare: false,
    masterAttractionCompare: false,
    businessBasicAgreement: false,
    updatedTerms: false,
    confirmDeleteSuggestedAccommodation: false,
    confirmRemoveAllAiAttractions: false,
    confirmRemoveAiAccommodation: false,
    confirmForceAiRideDateUpdate: false,
    myWhatsappNumber: false,
  },
  loked: false,
  dynamicModal: null,
  navigationTarget: null,
  inerModalParameters: null,
  inerModalParametersWereUsedWorkAround: false,

  // "Open the scheduled-message modal for this day."
  //
  // DayManagerOptions.vue is a GLOBAL modal in the Popups.vue registry,
  // while OrganizerMessageModal lives inside TripCalendarView.vue, where it
  // is wired to that view's @saved -> upsertOrganizerMessage. The day menu
  // therefore cannot reach it by $refs, and moving the modal into the
  // registry would cut it off from the upsert the list depends on. This
  // one-way signal is the smallest bridge: the day menu sets it, the
  // calendar watches it.
  //
  // The counter is load-bearing. Without it, picking the SAME day twice in
  // a row writes an identical value, Vue sees no change, the watcher never
  // fires and the second click does nothing at all.
  organizerMessageDayRequest: null,
  errorNumberConverter: {
    1: {
      text: "זה עבד",
      subText: "יופי תמשיכו",
      modalsName: "dynamicModal",
      action: "openLoginFormPresed",
      actionText: "ננסה שוב",
    },
    2: {
      text: "מצטערים",
      subText: "משהו לא עבד טוב - נטפל בזה",
      modalsName: "dynamicModal",
      action: "openLoginFormPresed",
      actionText: "ננסה שוב",
    },
    3: {
      text: "המשתמש לא רשום אצלינו במערכת",
      subText: "אתם בטוחים שנרשמתם?",
      modalsName: "dynamicModal",
      action: "openLoginFormPresed",
      actionText: "ננסה שוב",
    },
    4: {
      text: "סיסמא שגויה",
      subText: "גם לי זה קורה מידי פעם",
      modalsName: "dynamicModal",
      action: "openLoginFormPresed",
      actionText: "ננסה שוב",
    },
    5: {
      text: "אתם כבר רשומים אצלינו באתר",
      subText: "גם לי זה קורה מידי פעם",
      modalsName: "dynamicModal",
      action: "openLoginFormPresed",
      actionText: "ננסה שוב",
    },
    "userLoggedInSuccessfully": {
      text: "התחברתם בהצלחה",
      textTemplate: "התחברתם בהצלחה עם {addToText} ",
      subText: "עכשיו תוכלו להתחיל להשתמש במערכת ולעבוד עם המסלולים.",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "המשך",
    },
    "userRegisteredSuccessfully": {
      text: "נרשמתם בהצלחה",
      textTemplate: "נרשמתם בהצלחה עם {addToText}",
      subText: "אתם מחוברים, אפשר להתחיל!",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "המשך",
    },
    "startInsertRideLoginRequired": {
      text: "כדי להמשיך מנקודה זו יש להירשם למערכת",
      subText: "אנא התחברו או הירשמו כדי ליצור מסלול.",
      modalsName: "dynamicModal",
      action: "openLoginFormPresed",
      actionText: "התחברות או הרשמה",
    },
    "rideHaveOrderedAccommodation": {
      text: "אופס, יש לכם הזמנה של לינה",
      subText: "לא ניתן לערוך את הימים לאחר הכנסה של פרטי לינה, ניתן למחוק את פרטי הלינה ואז לערוך ",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה",
    },
    "fail_to_update_accommodation": {
      text: "אופס, משהוא השתבש בעדכון",
      subText: "תבדוק בבקשה שהכל עודכן כמו שצריך או צור איתנו קשר לתיקון ",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה",
    },
    "fail_to_update_attraction": {
      text: "אופס, משהו השתבש בעדכון הפעילות",
      subText: "תבדקו בבקשה שהכול עודכן כמו שצריך או צרו איתנו קשר לתיקון.",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה",
    },
    // update_ride_information_api's refusal of a description that sanitised
    // away to nothing -- markup only, no words. The guard runs before ANY
    // field is written, so the whole save is discarded, not just the
    // description: the copy has to say that, or a manager who also changed
    // the title and the traveller counts walks away believing those saved.
    "invalid_text": {
      text: "לא שמרנו כלום",
      subText: "הטקסט שהוזן בתיאור הטיול לא הכיל תוכן שאפשר לשמור (למשל תגיות עיצוב בלבד), ולכן שום שינוי לא נשמר - לא התיאור וגם לא שאר הפרטים שבטופס. תקנו את הטקסט ונסו לשמור שוב.",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה",
    },
    "fail_to_update_ride_text": {
      text: "לא הצלחנו לעדכן את תיאור הטיול",
      subText: "ייתכן שאין לך הרשאה לערוך את הטיול הזה. אפשר לנסות שוב או לערוך את התיאור במסך פרטי הטיול.",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה",
    },
    "user_is_not_authorized": {
      text: "אופס, למשתמש אין הרשאה לעשות את זה",
      subText: "תתנתק בבקשה ותתחבר שוב, זה אמור לעזור ",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה",
    },
    "error_no_access_to_attraction": {
      text: "אין לך גישה לאטרקציה זו",
      subText: "אנא בדוק שיש לך הרשאות מתאימות או צור קשר עם בעל הטיול",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה"
    },
    "date_are_not_in_range": {
      text: "אופס, התאריכים לא תואמים לטיול",
      subText: "נסו לתקן בבקשה",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה",
    },
    "you_Are_having_double_booking": {
      text: "אופס, יש כבר הזמנה על חלק מהימים",
      subText: "נסו לתקן בבקשה",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה",
    },
    "uesr_is_not_authorize_to_edit_this_ride": {
      text: "אין לכם אפשרות לערוך את הטיול הזה",
      subText: "בחרו בכפתור ערוך את הטיול ונסו שוב",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה",
    },
    "scroll_down_to_see_the_added_day": {
      text: "הוספתם יום לטיול",
      subText: "צריך לרדת קצת בעמוד כדי לראות אותו",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה",
    },
    "the_day_wewre_delited_and_the_activites_pushed_to_the_next_day": {
      text: "מחקתם יום מהטיול",
      subText: "כל הפעילויות של אותו היום עברו ליום אחד אחרי, ניתן להוריד אותן אים רוצים",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה",
    },
    "uesr_is_adding_new_ride": {
      text: "איזה כיף שבחרתם לשתף",
      subText: "בואו נתחיל בהכנסת פרטים כללים של הטיול ",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה",
    },
    "uesr_copyed_new_ride": {
      text: "איזה כיף שזה הטיול שבחרתם",
      subText: "חשוב לעדכן את תאריך תחילת הטיול, ומיד אחרי תוכלו לעדכן את הטיול לפי הצרכים שלכם",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה",
    },
    "ride_reset_success": {
      text: "הטיול אופס בהצלחה",
      subText: "הטיול הוחזר למצבו המקורי לפני השינויים שביצעתם",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה",
    },
    "ride_reset_error": {
      text: "שגיאה באיפוס הטיול",
      subText: "מצטערים, לא הצלחנו לאפס את הטיול. אנא נסו שנית או פנו לתמיכה",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה",
    },
    "please_use_auto_compleate": {
      text: "השתמשו באפשרויות של המילוי האוטומטי",
      subText: "בחרו את אחת האפשרויות",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה",
    },
    "sorry_we_dont_have_this_ride_please_add_it_at_your_return": {
      text: "עדיין אין לנו טיול לאיזור הזה",
      subText: "אנחנו נשמח אם תוסיפו אותו כשתחזרו",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה",
    },
    "updating_the_ride": {
      text: "מעלה נתונים",
      subText: "אנחנו מעדכנים את הטיול שלכם",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה",
    },
    "user_guide_for_editing": {
      text: "ידעתם שאפשר להעתיק את הטיול הזה ולערוך אותו?",
      subText: "אפשר להוסיף פעילויות מטיולים שמשפחות אחרות עשו באותו אזור!",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה",
    },
    "new_ride_detailes_form": {
      text: "יצרנו דרך נוספת וממש פשוטה להעלות טיול",
      subText: "תרצו שניצור אתכם קשר להסבר?",
      modalsName: "dynamicModal",
      action: "goToAddRideWithAlboumDetailesForm",
      actionText: "כן",
    },
    "account_exists_with_different_credential": {
      text: "המייל כבר רשום עם חיבור ממקור אחר",
      subText: "התחברות בעזרת המערכת שנרשמתם בפעם הראשונה",
      modalsName: "dynamicModal",
      action: "openLoginFormPresed",
      actionText: "ננסה שוב",
    },
    "email_is_not_baind_to_this_acount": {
      text: "אין מייל משויך לחשבון זה",
      subText: "לא ניתן להתחבר ללא מייל שמשויך לחשבון",
      modalsName: "dynamicModal",
      action: "openLoginFormPresed",
      actionText: "ננסה שוב",
    },
    "connect_me_for_adding_new_ride": {
      text: "כדי לקבל אפשרות לשתף את הטיול שעשיתם באתר",
      subText: "יש ליצור איתנו קשר ב 052-686-7915",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה",
    },
    "upload_trip_adding_text_stage": {
      text: "יש!! העלנו את המסלול",
      subText: "בשלב הזה אפשר לרשום את השם שנרצה לחפשה וקצת דברים כללים על החופשה",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה",
    },
    "all_images_dates_are_empty": {
      text: "כל התמונות לא מכילות מידע על זמן הצילום",
      subText: "כדי שזה יעבוד צריך להשתמש בתמונות האמיתיות מהטלפון שצילם אותם",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה",
    },
    "limiting_the_trip_duration": {
      text: "אורך המסלול מוגבל ל 60 יום",
      subText: "נא להעלתות טיול של עד 60 יום",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה",
    },
    "all_images_without_metadata": {
      text: "אין נתונים מהתמונות",
      subText: "כרגע אנו לא תומכים בתמונות שלא צולמו מהמכשיר שממנו מעלים את התמונות",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה",
    },
    "waiting_to_get_image_info": {
      text: "אני מבצע עיבוד על התמונות כדי להבין איפה הן צולמו",
      subText: "זה יכול לקחת עד 30 שניות",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "",
      spionr: true,
    },
    "waiting_to_get_image_info_without_gps_information": {
      text: "אני מבצע עיבוד על התמונות כדי להבין איפה הן צולמו",
      subText: "התהליך עשוי להימשך עד 30 שניות. מאחר ובתמונות שהועלו אין נתוני מיקום, זיהוי המיקום עשוי לקחת זמן רב יותר.",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "",
      spionr: true,
    },
    "api_call_failed": {
      text: "אירעה תקלה בתהליך הניתוח",
      subText: "אנא נסה שוב מאוחר יותר. אם הבעיה נמשכת, ניתן לפנות לתמיכה בטלפון: 052-6867915",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "",
      spionr: true,
    },
    "plese_add_the_activity_info": {
      text: "יש לנו טיול מוכן! עכשיו זה הזמן לתת את הטיפים למקומות",
      subText: "אתם יכולים כרגע לעבור על כל האטרקציות ולתת את הטיפים שלכם כדי לעזור למשפחות שיטיילו שם למקסם את החוויה שלהם מהמקום",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה"
    },
    "plese_add_the_accommodation_dates": {
      text: "יש להכניס את הימים שישנתם באותו המקום",
      subText: "כדאי לאפשר לאחרים לדעת כמה לילות להזמין למקום זה יש צורך בהכנסת תאריך הכניסה והיציאה ממקום לינה זה",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה"
    },
    "not_supporting_FB_or_instagram_browsers": {
      text: "לא ניתן להתחבר דרך G-Mail בדפדפן זה",
      subText: "נראה שאתם משתמשים בדפדפן של Facebook או Instagram. נא לפתוח בדפדפן רגיל כמו Safari או Chrome",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה"
    },
    "fail_to_add_user_to_ride_privacy": {
      text: "משהו השתבש בעדכון ההרשאות",
      subText: "אנא בדוק שהכל עודכן כהלכה. אם הבעיה נמשכת, צור איתנו קשר ונשמח לעזור בתיקון.",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה",
    },
    // we are not presenting this any more 
    "this_user_is_alrady_assign_to_this_ride":{
      text: "המשתמש כבר רשום לטיול זה",
      subText: "אין צורך להשתמש בלינק הנוכחי. העתקו את הלינק שמופיע בעמוד זה.",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה",
    },  
    "user_does_not_have_permission_to_this_private_ride":{
      text: "מסלול זה מוגבל למשתמשים מורשים בלבד.",
      subText: "נא להירשם או להתחבר כדי לגשת למסלול זה.",
      modalsName: "dynamicModal",
      action: "openLoginFormPresed",
      actionText: "התחברות או הרשמה",
    },
    "blocked": {
      modalsName: "navigate",
      navigateTo: "/blocked",
    },
    "parent_redirect_page_missing": {
      modalsName: "navigate",
      navigateTo: "/blocked",
    },
    "ride_link_activated": {
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה",
    },
    "key_is_not_exsist": {
      text: "הלינק שהוזן אינו תקין",
      subText: "אנא פנו למי שסיפק לכם את הלינק כדי לקבל קישור תקין.",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה",
    },
    "the_private_link_is_not_valide": {
      text: "הלינק שהוזן אינו תקין",
      subText: "אנא פנו למי שסיפק לכם את הלינק כדי לקבל קישור תקין.",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה"
    },
    "ritch_to_ride_limitation": {
      text: "הלינק הגיעה למכסת משתמשים",
      subText: "אנא פנו אל מי שסיפק לכם את הקישור כדי להגדיל את מכסת המשתמשים.",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה"
    },
    "error_ride_is_not_from_subdomain": {
      text: "לא ניתן להעתיק את הטיול",
      subText: "הטיול שייך לקבוצה אחרת. פנה למי שסיפק לך את הקישור.",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה"
    },
    "error_ride_is_not_from_the_right_user": {
      text: "לא ניתן להעתיק את הטיול",
      subText: "בעלי הטיול אינם שייכים לקבוצה. יש לפנות למי שסיפק לך את הקישור.",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה"
    },
    "atraction_text_box_is_not_empty": {
      text: "אסור לי למחוק מידע שכבר הכנסתם",
      subText: "נא לרוקן את הטקסט שבתיבת 'תיאור האטרקציה' ולנסות שוב.",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה"
    },
    "the_day_and_its_activities_were_deleted": {
      text: "מחקתם יום ואת כל הפעילויות שבו",
      subText: "היום וכל הפעילויות שלו הוסרו מהטיול בהצלחה.",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה",
    },
    "day_activities_moved_successfully": {
      text: "העברתם את כל הפעילויות של היום",
      subText: "הפעילויות הועברו בהצלחה ליום שבחרתם.",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה",
    },
    invalid_email_spaces: {
      text: "כתובת המייל לא תקינה",
      subText: "כתובת המייל לא יכולה להכיל רווחים",
      modalsName: "dynamicModal",
      action: "openLoginFormPresed",
      actionText: "ננסה שוב",
    },
    invalid_email_format: {
      text: "כתובת המייל לא תקינה",
      subText: "אנא הכנס כתובת מייל חוקית",
      modalsName: "dynamicModal",
      action: "openLoginFormPresed",
      actionText: "ננסה שוב",
    },
    "day_not_in_trip_range": {
      text: "אופס, יום זה לא חלק מהטיול",
      subText: "בחרו יום בטווח התאריכים של הטיול",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה",
    },
    "unbooked_accommodation_info": {
      text: "הכניסו את פרטי המלון שלכם עבור הימים הרלוונטיים",
      subText: "אנא הזינו את פרטי המלונות שהזמנתם, כדי שיופיעו בתוכנית הטיול שלכם",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה",
    },
    "password_reset_email_sent": {
      text: "הוראות לאיפוס הסיסמה נשלחו",
      subText: "בדוק את תיבת הדואר האלקטרוני שלך",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגור"
    },
    "password_reset_failed": {
      text: "שגיאה באיפוס הסיסמה",
      subText: "אנא נסה שוב או פנה לתמיכה",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגור"
    },
    "password_reset_success": {
      text: "הסיסמה עודכנה בהצלחה",
      subText: "כעת תוכל להתחבר לחשבונך דרך הקישור המקורי שקיבלת",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "הבנתי"
    },
    "please_close_tab": {
      text: "ניתן לסגור את הכרטיסייה",
      subText: "הסיסמה עודכנה בהצלחה. אנא סגור כרטיסייה זו וחזור לקישור המקורי",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "הבנתי"
    },
    "password_too_short": {
      text: "הסיסמה קצרה מדי",
      subText: "הסיסמה חייבת להכיל לפחות 6 תווים",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגור"
    },
    "passwords_dont_match": {
      text: "הסיסמאות אינן תואמות",
      subText: "אנא וודא שהזנת את אותה סיסמה בשני השדות",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגור"
    },
    "password_required": {
      text: "סיסמה נדרשת",
      subText: "אנא הכנסו סיסמה להרשמה",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגור"
    },
    "invalid_reset_token": {
      text: "קישור לא תקין",
      subText: "קישור איפוס הסיסמה אינו תקין או שפג תוקפו",
      modalsName: "dynamicModal",
      action: "openLoginFormPresed",
      actionText: "חזור להתחברות"
    },
    "google_oauth_user": {
      text: "החשבון התחבר דרך חשבון GOOGLE",
      subText: "אנא התחבר דרך חשבון ה GMAIL שלך",
      modalsName: "dynamicModal",
      action: "openLoginFormPresed",
      actionText: "חזור להתחברות"
    },
    "password_reset_failed_user_is_not_registered": {
      text: "החשבון הזה לא רשום במערכת",
      subText: "יש להתחבר למערכת עם מייל זה",
      modalsName: "dynamicModal",
      action: "openLoginFormPresed",
      actionText: "חזור להתחברות"
    },
    "pdf_generation_warning": {
      text: "⚠️ יצירת PDF יכולה לקחת עד 3 דקות!",
      subText: "אנא המתן ואל תסגור את הדפדפן. התהליך יתחיל בעוד רגע.",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "הבנתי"
    },
    "pdf_generated_successfully": {
      text: "קובץ ה-PDF נוצר בהצלחה!",
      subText: "הקובץ הורד למכשיר שלך",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה"
    },
    "pdf_generation_failed": {
      text: "שגיאה ביצירת קובץ ה-PDF",
      subText: "אנא נסה שוב או פנה לתמיכה",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה"
    },
    "pdf_rate_limited": {
      text: "יצירת PDF מוגבלת",
      subText: "ניתן ליצור PDF אחד כל 2 דקות. אנא המתן ונסה שוב.",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה"
    },
    "ride_data_not_loaded": {
      text: "מידע הטיול לא נטען כהלכה",
      subText: "אנא רענן את הדף ונסה שוב",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה"
    },
    "insufficient_balance": {
      text: "הקרדיט הראשוני שלך נוצל",
      subText: "כדי להמשיך לשתף מסלולים ולפתוח את החשבון לשימוש נוסף, אפשר ליצור איתנו קשר ונשמח לעזור לך להתחיל לעבוד בצורה שוטפת.\n\nניתן להמשיך לבנות ולערוך מסלולים ללא הגבלה",
      modalsName: "insufficientBalanceModal",
      action: "openWhatsAppContact",
      actionText: "צרו קשר בווצאפ"
    },
    "contact_form_success": {
      text: "הודעתכם נשלחה בהצלחה!",
      subText: "נחזור אליכם בהקדם האפשרי",
      actionText: "אישור",
      action: "closePopup",
      modalsName: "dynamicModal",
      spionr: false
    },
    "contact_form_error": {
      text: "שגיאה בשליחת ההודעה",
      subText: "אנא נסו שוב מאוחר יותר או צרו קשר בדרך אחרת",
      actionText: "אישור",
      action: "closePopup",
      modalsName: "dynamicModal",
      spionr: false
    },
    "name_required": {
      text: "שם מלא נדרש",
      subText: "אנא הכניסו את שמכם המלא",
      actionText: "אישור",
      action: "closePopup",
      modalsName: "dynamicModal",
      spionr: false
    },
    "phone_required": {
      text: "מספר טלפון נדרש",
      subText: "אנא הזינו מספר טלפון כדי שנוכל לחזור אליכם",
      actionText: "אישור",
      action: "closePopup",
      modalsName: "dynamicModal",
      spionr: false
    },
    "phone_invalid": {
      text: "מספר טלפון לא תקין",
      subText: "נא להזין 8-15 ספרות (מספר בינלאומי כולל, למשל +972)",
      actionText: "אישור",
      action: "closePopup",
      modalsName: "dynamicModal",
      spionr: false
    },
    "master_accommodation_already_exists": {
      text: "שינית את המלון למלון אחר שכבר קיים במאגר שלך",
      subText: "כדי למנוע דריסה של פרטים קיימים, לא בוצע עדכון אוטומטי\n\nאם ברצונך לעדכן את המלון, ניתן לעשות זאת ישירות דרך מאגר המלונות",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה",
    },
    "message_required": {
      text: "הודעה נדרשת",
      subText: "אנא הכניסו את תוכן ההודעה שלכם",
      actionText: "אישור",
      action: "closePopup",
      modalsName: "dynamicModal",
      spionr: false
    },
    "gui_version_outdated": {
      text: "המערכת עודכנה ונדרש רענון של העמוד כדי להמשיך לעבוד.",
      subText: "העמוד יתרענן אוטומטית בעוד כ-7 שניות.\nייתכן שחלק מהשינויים האחרונים לא נשמרו.",
      actionText: "הבנתי",
      action: "closePopup",
      modalsName: "dynamicModal",
      spionr: false
    },
    "record_user_agreement_failed": {
      text: "לא ניתן לשמור את אישור ההסכם",
      subText: "אנא נסו שוב בעוד רגע. אם הבעיה נמשכת, צרו קשר עם התמיכה.",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה",
    },
    "make_user_ride_manager_failed": {
      text: "לא ניתן לפתוח הרשאות מנהל מסלול",
      subText: "אנא נסו שוב או צרו קשר עם התמיכה.",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה",
    },
    "business_basic_agreement_required": {
      text: "נדרש אישור הסכם השימוש לעסקים",
      subText: "יש לאשר את תנאי השימוש לפני פתיחת הרשאות מנהל מסלול.",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה",
    },
    "business_basic_agreement_phone_required": {
      text: "חסר מספר טלפון",
      subText: "יש להזין מספר טלפון כדי לאשר את ההסכם.",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה",
    },
    "business_basic_agreement_phone_invalid": {
      text: "מספר טלפון לא תקין",
      subText: "נא להזין 8-15 ספרות (מספר בינלאומי כולל).",
      modalsName: "dynamicModal",
      action: "closePopup",
      actionText: "סגירה",
    }
  }

};

const getters = {
  modals: state => state.modals,
  dynamicModal: state => state.dynamicModal,
  navigationTarget: state => state.navigationTarget,
  errorNumberConverter: state => state.errorNumberConverter,
  inerModalParameters: state => state.inerModalParameters,
  inerModalParametersWereUsedWorkAround: state => state.inerModalParametersWereUsedWorkAround,
  organizerMessageDayRequest: state => state.organizerMessageDayRequest,
  
};

let organizerMessageDayRequestCounter = 0;

const actions = {
  // dateStr is 'YYYY-MM-DD', derived by the caller from the trip's own
  // start_date + dayIndex (the same derivation as dateForDayIndex in
  // organizerMessagesMixin), never from a calendar cell's Date object.
  requestOrganizerMessageForDay({ commit }, dateStr) {
    organizerMessageDayRequestCounter += 1;
    commit('setOrganizerMessageDayRequest', {
      dateStr,
      requestId: organizerMessageDayRequestCounter
    });
  },

  lockShowModalOnce({ state } ) {
    state.loked = true;
  },
  resetInerParametersIfNesesery({ state, commit } ) {
    if( state.inerModalParametersWereUsedWorkAround )
      commit('setInerModalParameters', null);
    else{
      state.inerModalParametersWereUsedWorkAround=true;
    }
  },

  showModal({ state, dispatch }, modal) {
    dispatch( 'resetInerParametersIfNesesery');
    if( state.loked ){
      if( modal == ""){
        state.loked = false;
        console.log( "releasing the modal locked")
      }
      return;
    }
    var modals = state.modals;
    for (const key in modals) {
      modals[key] = false;
    }
    if (!(modal in modals)&&(modal!='')) {
      console.error(`Error: The modal "${modal}" is not part of the available modals.`);
      return;  // Exit the function if the modal is invalid
    }
    modals[modal] = true;

  },

  showModalWithParameters({ state, commit, dispatch }, modalInfo) {
    var modals = state.modals;
    const { errorNumberConverter } = state;
    for ( const key in modals ) {
      modals[ key ] = false;
    }
    if( modalInfo.type=='textConverter')
    {
      if( modalInfo.errorNumber in errorNumberConverter ){
        var dynamicModalContaent = { ...errorNumberConverter[ modalInfo.errorNumber ] }
        if( modalInfo.errorNumber == "userLoggedInSuccessfully" || modalInfo.errorNumber == "userRegisteredSuccessfully" ){
          dynamicModalContaent.text = dynamicModalContaent.textTemplate.replace('{addToText}', modalInfo.textToAdd || '')
        }
        // Attach translation keys so DynamicModal can use i18n
        const id = String(modalInfo.errorNumber);
        dynamicModalContaent.id = id;
        dynamicModalContaent.textKey = `popup_${id}_text`;
        dynamicModalContaent.subTextKey = `popup_${id}_subText`;
        dynamicModalContaent.actionTextKey = `popup_${id}_action`;
        // Values for placeholders in the translated text, e.g. seconds to wait
        dynamicModalContaent.textParams = modalInfo.textParams || {};
        if( dynamicModalContaent.modalsName === 'navigate' ){
          commit( 'setNavigationTarget', { path: dynamicModalContaent.navigateTo } );
          return;
        }
        commit( 'setDynamicModal', dynamicModalContaent );
        modals[ dynamicModalContaent.modalsName ] = true;
      }
      else{
        console.log( modalInfo.errorNumber, " This error is not define !!!!!!!!!!!!!!" )
      }
    }

    if( modalInfo.inerModalParameters)
    {
      state.inerModalParametersWereUsedWorkAround=false;
      commit('setInerModalParameters', modalInfo.inerModalParameters);
      if( modalInfo.type=='shareAttraction')
        dispatch( 'showModal', "shareRide" );
      else
        dispatch( 'showModal', modalInfo.type );
    }
  },
};

const mutations = {
  setModal: ( state, modal ) => {
    for (const key in state.modals) {
      state.modals[key] = false;
    }
    state.modals[modal] = true;  
  },
  setModals: ( state, modals ) => {
    state.modals = modals;
  },
  setDynamicModal: ( state, dynamicModal) => {
    state.dynamicModal = dynamicModal;
  },
  setInerModalParameters: ( state, inerModalParameters) => {
    state.inerModalParameters = inerModalParameters;
  },
  setNavigationTarget: ( state, target ) => {
    state.navigationTarget = target;
  },
  setOrganizerMessageDayRequest: ( state, request ) => {
    state.organizerMessageDayRequest = request;
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};
